export default __webpack_public_path__ + "static/Roads_2-dcd2c844ec8a893eaa2efb66855e7f7c.png";